<template>
  <div class="container-fluid">
    <div class="complaints-header">
      <router-link class="btn btn-circle torre-red" :to="{ name: 'complaintsNew' }" title="Dodaj reklamację">
        <i class="material-icons" >
        add
        </i>
      </router-link>
        <select class="form-control form-control-sm ml-3" v-model="status" style="width: auto; display: inline-block;">
          <option v-for="option in statusesOptions" :key="option.id" v-bind:value="option.id" >
          {{ option.text }}
          </option>
      </select>
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col" style="width: 8%">
              Data przyjęcia
          </th>
          <th scope="col" style="width: 18%">
              <input class="form-control form-control-sm"
              type="text" placeholder="Nazwa produktu"
              v-model="search.productName">
          </th>
          <th scope="col" style="width: 25%">
              Opis
          </th>
          <th scope="col" style="width: 15%">
              <input class="form-control form-control-sm"
              type="text" placeholder="Telefon kontaktowy"
              v-model="search.contactPhone">
          </th>
          <th scope="col" style="width: 10%">
              Termin reklamacji
          </th>
          <th scope="col" style="width: 10%">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id" :class="determineClass(item)">
          <td>{{ item.createdAt }}</td>
          <td>{{ item.productName }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.contactPhone }}</td>
          <td v-html="itemCounterInfo(item)"></td>
          <td><router-link :to="{ name: 'complaintsEdit', params: { id: item.id} }">edycja / podgląd</router-link></td>
        </tr>
      </tbody>
    </table>
    <div v-if="showEmptyResult" class="row">
      <div class="col text-center">
        Brak wyników
      </div>
    </div>
    <common-pagination @paginationClicked="onPaginationClicked"/>
  </div>
</template>
<script>
import un from 'underscore'
import restClient from '@/components/complaints/ComplaintsRestClient'
import service from '@/components/complaints/ComplaintsService'

export default {
  name: 'Complaints',
  data: function () {
    return {
      loading: false,
      currentPage: 0,
      status: "ACTIVE",
      statusesOptions: service.availableStatusesForSearch(),
      search: {
        productName: "",
        contactPhone: ""
      },
      items: [],
    }
  },
  created() {
    this.loadItems()
  },
  watch: {
    'search.productName': un.debounce(function () {
    	this.tryPerformSearch()
    }, 500),
    'search.contactPhone': un.debounce(function () {
    	this.tryPerformSearch()
    }, 500),
    status() {
      this.loadItems()
    }
  },
  computed: {
    showEmptyResult() {
      return this.loading === false && this.items.length === 0
    }
  },
  methods: {
    determineClass: function(item) {
      return service.determineClass(item)
    },
    itemCounterInfo(item) {
      return service.itemCounterInfo(item)
    },
    tryPerformSearch() {
      if (service.canSearch(this.search)) {
        this.loadItems()
      }
    },
    loadItems() {
      this.loading = true
      let data = service.prepareSearch(this.search)
      data.status = this.status
      restClient
        .fetchItems(this.currentPage, data)
        .then(res => {
          this.loading = false
          this.items = res.data.items
          this.notifyDataChanged(res)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    onPaginationClicked(payload) {
      this.currentPage = payload.pageToSend
      this.loadItems()
    },
    notifyDataChanged(res) {
      this.$emit('dataChanged', {
          data: res.data
        });
    }
  }
}
</script>
<style lang="scss" scoped>

  .complaints-header {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

</style>



// WEBPACK FOOTER //
// src/components/complaints/Complaints.vue